import { IconDefinition } from '@ant-design/icons-angular';

export const DotChartOutline: IconDefinition = {
    name: 'dot-chart',
    theme: 'outline',
    icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 10128 0 64 64 0 10-128 0zm118-224a48 48 0 1096 0 48 48 0 10-96 0zm158 228a96 96 0 10192 0 96 96 0 10-192 0zm148-314a56 56 0 10112 0 56 56 0 10-112 0z" /></svg>'
}